import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import addressesActionKeys from './addressesActionKeys';

export default combineReducers({
  addressesInfo: AsyncRequest.createReducer(addressesActionKeys.GET_SP_ADDRESSES),
});



// WEBPACK FOOTER //
// ./src/modules/store/common/addressesReducer.js